// Web mock for @react-native-community/datetimepicker
import React from 'react';

function flattenStyle(style) {
  if (Array.isArray(style)) {
    return Object.assign({}, ...style.filter(Boolean));
  }
  return style || {};
}

const DateTimePicker = ({ value, mode = 'date', onChange, ...props }) => {
  const handleChange = (event) => {
    const date = new Date(event.target.value);
    if (onChange) {
      onChange({ type: 'set', nativeEvent: { timestamp: date.getTime() } }, date);
    }
  };

  const inputType = mode === 'time' ? 'time' : mode === 'datetime' ? 'datetime-local' : 'date';
  const inputValue = value ? value.toISOString().slice(0, inputType === 'time' ? 5 : inputType === 'date' ? 10 : 16) : '';

  return React.createElement('input', {
    type: inputType,
    value: inputValue,
    onChange: handleChange,
    style: { padding: '8px', border: '1px solid #ccc', borderRadius: '4px', ...flattenStyle(props?.style) },
    ...props,
  });
};

export default DateTimePicker;
